import { useParams } from "react-router-dom";

const useId = () => {
  const { id } = useParams<{ id: string }>();
  return parseInt(id);
};

export default useId;
